/* lib/decimal.js — ввод десятичных чисел: точка и запятая равнозначны (RU-раскладка).
   normalizeDecimalText — для ЗНАЧЕНИЯ: чистит мусор, «,» → «.», сохраняет незавершённый
   ввод («561.», «-»). parseDecimal — терпимый Number() поверх той же эквивалентности
   (пусто/мусор → NaN, у вызывающего свой guard). toCommaDecimal — для ГЛАЗ: то же число
   с запятой (K-40: в RU разделитель дроби — запятая; хранимое значение не меняется). */

export const normalizeDecimalText = (s) =>
  String(s ?? '').replace(/[^\d.,\-]/g, '').replace(/,/g, '.');

export const parseDecimal = (v) =>
  (v == null || String(v).trim() === '') ? NaN : Number(String(v).replace(/[ \u00A0\u202F]/g, '').replace(/,/g, '.'));

export const toCommaDecimal = (v) =>
  (v == null ? '' : String(v).replace(/\./g, ','));
